import React, { useEffect, useState } from 'react'
// import SponsorRegistrationP1 from './components/Page1'
import MDFormL from './components/MDFormL';
import DashboardFormK from './components/DashboardMenuFormK';
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getOneContractFarmingDetails } from '../../../auth/services/privateapicalling';

const MarketingBoardRegIndex = () => {

 const location =useLocation()
 const applicationId=location?.state?.applicationId

  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const [applicationDataInfo, setApplicationDataInfo] = useState<any>(null);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
  const [appStatusLevel, setAppStatusLevel] = useState("")
  //----------------------------- CHANGE ROLE IDENTIFIER HERE OR IMPORTTTT----------------------------------

    const fetchApplicationData = async (applicationId: string) => {
      try {
        setLoading(true);
        const result = await getOneContractFarmingDetails(applicationId, token);
  
        if (result.success && result.data) {
          setApplicationDataInfo(result.data);
          setRemarks(result.data?.Remark || "");
          setAppStatusLevel(result?.data?.appStatusLevel)
         
        } else {
          toast.warning("No previous data found", { position: "top-right" });
        }
      } catch (error) {
      
        toast.error("Failed to load application data", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };
  
  
  
  
    useEffect(() => {
      if (applicationId) {
        fetchApplicationData(applicationId);
      }
    }, [applicationId]);


  return (
    <div>
      <div className="position-fixed page-wrapper start-0 end-0 z-3 border-bottom"
        style={{
          backgroundColor: "#f8f9fa", // or specify same color code
        }}>
        <div className=" w-100">
          <h2 className='mx-5 m-3'>
            Sponsor Registration - Form {roleIdentifier === "MBMD" ? "L" : "K"}
          </h2>
          <div className='mx-5'>
            <p className='pb-3'>Review and verify sponsor registration applications. Take necessary actions to approve and send to managing director for approval.</p>
            {/* <h4 className='text-info pb-3'>Sponsor ID: 789456</h4> */}
          </div>
        </div>
      </div>
      {/* Spacer for Fixed Header */}
      <div style={{ height: "90px" }}></div>

        {!loading ? 
        (<div className="page-wrapper">
        {(roleIdentifier === "MBA" || roleIdentifier === "MBMD") && (appStatusLevel==="pendingAtMBA" || appStatusLevel==="pendingAtMBAResubmission") && (
          <DashboardFormK
          applicationId={applicationId}
          applicationDataInfo={applicationDataInfo}
          remarks={remarks}
          loading={loading}
          />)}
        {roleIdentifier === "MBMD" && (appStatusLevel==="pendingAtMBMD" || appStatusLevel==="pendingAtMBMDResubmission") && (
          <MDFormL
            applicationId={applicationId}
          />
        )}

      </div>):
      (<div className=" page-wrapper text-center p-5 mt-5">
          <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
          </div>
      </div>)}
      
      <ToastContainer position="top-left" autoClose={3000} />
    </div>
  )
}

export default MarketingBoardRegIndex